import DividerLine from "components/common/divider/line";
import SkeletonBlock, { SkeletonBlock2 } from ".";

export const DiscussListSkeleton = () => {
  return (
    <div className="flex flex-col">
      <div className="px-6 pt-6">
        <SkeletonBlock width={120} height={24} radius={8} />
      </div>
      <div className="flex flex-col  py-2">
        <div className="px-6 py-4">
          <SkeletonBlock width={"100%"} height={120} radius={8} />
        </div>
        <div className="px-6 py-4">
          <SkeletonBlock width={"100%"} height={120} radius={8} />
        </div>
      </div>
      <DividerLine size="lg" />
      <div className="px-6 pt-6">
        <SkeletonBlock width={120} height={24} radius={8} />
      </div>
      <div className="flex flex-col gap-2 py-2">
        <div className="px-6 py-4">
          <SkeletonBlock width={"100%"} height={120} radius={8} />
        </div>
      </div>
    </div>
  );
};

export const DiscussDetailSkeleton = () => {
  return (
    <div className="flex flex-col gap-4">
      <div className="px-6 pt-6 flex flex-col justify-center items-center gap-2">
        <SkeletonBlock2 width={132} height={32} radius={10} />
      </div>
      <div className="py-6 px-6">
        <SkeletonBlock2 width={"100%"} height={160} radius={10} />
      </div>
      <div className="py-2 px-6 flex flex-col gap-2 items-center">
        <SkeletonBlock2 width={80} height={25} radius={10} />
        <SkeletonBlock2 width={200} height={30} radius={10} />
      </div>
    </div>
  );
};

export const DebateSkeleton = () => {
  return (
    <div className="flex flex-col gap-4 bg-white">
      <div className="px-6 py-2 ">
        <SkeletonBlock2 width={"100%"} height={107} radius={10} />
      </div>
      <div className="flex flex-col gap-2 ">
        <div className="py-2 px-6  bg-white flex items-center">
          <SkeletonBlock2 width={"100%"} height={30} radius={10} />
        </div>
        <div className="flex flex-col gap-3 bg-white pb-9">
          <DiscussDetailDebateSkeleton />
          <DiscussDetailDebateSkeleton />
          <DiscussDetailDebateSkeleton />
          <DiscussDetailDebateSkeleton />
          <DiscussDetailDebateSkeleton />
        </div>
      </div>
    </div>
  );
};

export const DiscussDetailDebateSkeleton = () => {
  return (
    <div className="flex px-4 w-full">
      <div className="gap-2 flex items-stretch w-full">
        <div className="flex flex-col py-2 gap-2 h-full ">
          <SkeletonBlock2 width={24} height={24} radius={"100%"} />
        </div>
        <div className="flex flex-col grow">
          <div className="flex flex-col gap-1 py-2 h-full">
            <SkeletonBlock2 width={80} height={20} radius={10} />
            <SkeletonBlock2 width={"80%"} height={50} radius={10} />
            <SkeletonBlock2 width={"100%"} height={30} radius={10} />
          </div>
        </div>
      </div>
    </div>
  );
};

export const OpinionDetailSkeleton = () => {
  return (
    <div className="flex flex-col  bg-white">
      <div className="px-5 py-2 flex flex-col gap-3">
        <SkeletonBlock width={80} height={24} radius={10} />
        <SkeletonBlock width={"60%"} height={50} radius={10} />
        <SkeletonBlock width={"100%"} height={30} radius={10} />
      </div>
      <DividerLine size="md" />
      <div className="flex flex-col">
        <div className="px-5 py-6">
          <SkeletonBlock width={"100%"} height={131} radius={10} />
        </div>
        <div className=" py-2 flex flex-col gap-2">
          <DiscussDetailDebateSkeleton />
          <DiscussDetailDebateSkeleton />
        </div>
      </div>
    </div>
  );
};
